// extracted by mini-css-extract-plugin
export default {"varInfo":"VarItem_varInfo__FNOXv","varNumber":"VarItem_varNumber__K9rmE","varTitle":"VarItem_varTitle__5WBDV"};